  $('#track-order-form').on('submit', function (e) {
    e.preventDefault();

    let orderId = $('#input-order-mobile').val().trim().replace(/#/g, '');
    if (!orderId) {
      alert('Please enter your Order ID');
      return;
    }

$('.order_id').text(orderId);

let apiUrl = `https://services.namyaa.in/trackorder/track?orderid=${encodeURIComponent(orderId)}`;

$('#popup-content').text('Loading...');
$('#track-popup').show();

// CALL API
$.get(apiUrl, function (response) {
    
    // DEBUG
    console.log("API Response:", response);

    // access track_url safely
    const trackUrl = response.data.ShipmentData[0].tracking_data.track_url;
   console.log("API trackUrl:", trackUrl);
    // put URL in button
    $('.cnt-btn').data('track-url', trackUrl);

    // show tracking details if needed
    $('#popup-content').text("Tracking loaded");

}).fail(function () {
    $('#popup-content').text('Failed to load tracking.');
});
$(document).on("click", ".cnt-btn", function (e) {
    e.preventDefault();

    const url = $(this).data('track-url');

    if (url) {
        window.open(url, "_blank");
    } else {
        console.error("Track URL not found");
    }
});
  });
